import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private url = 'products';
  constructor(public restService: RestService) { }

  get() {
    return this.restService.get(this.url);
  }

  post(payload) {
    return this.restService.post(this.url,payload);
  }

  patch(id, payload) {
    return this.restService.patch(this.url, payload, id);
  }

  remove(id) {
    return this.restService.delete(this.url, id);
  }
}
